<template>
  <div>
    <div class="d-flex col-12 p-0 mt-3">
      <div class="col-lg-5 col-5 px-2 transaction">
        <v-select
          v-model="filters.date"
          :reduce="(draw) => draw.data"
          label="label"
          :options="dateOptions"
        ></v-select>
      </div>
      <div>
        <button
          type="button"
          class="px-3 py-1 !rounded-md text-white border-[1px] border-white"
          style="flex-shrink: 0"
          @click="
            filters.page = 1;
          fetchUserDeposits();
          "
        >
          {{ $t("transaction.all") }}
          {{ $t("transaction.search") }}
        </button>
      </div>
    </div>
    <div>
      <div
        class="d-flex justify-content-center align-items-center mx-auto my-5 text-white"
        v-if="isDepositsFetching"
      >
        <Loading
          size="24"
          class="px-2 py-0"
        />
        <span> {{ $t('loading') }} ... </span>
      </div>
      <div
        class="mx-auto my-5"
        v-else-if="deposits.length === 0"
      >
        <h3 class="text-center text-white">
          {{ $t('history.no_deposits_found') }}
        </h3>
      </div>
      <!-- TABLE -->
      <table
        class="history-table"
        v-else
      >
        <thead>
          <tr>
            <th>{{ $t("voucher.total_amount") }}</th>
            <th>{{ $t("transaction.status") }}</th>
            <th>{{ $t("history.form_submit_date") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(data, index) in deposits"
            :key="index"
          >
            <td>{{ data.amount }}</td>

            <td>
              <span
                class="status-badge"
                :class="data.status"
              >
                {{ getStatusLabel(data.status) }}
              </span>
            </td>

            <td>{{ data.date ?? '-' }}</td>
          </tr>
        </tbody>
      </table>

      <p class="total-text">{{ $t('history.total_deposits') }} - {{ depositData?.total }}</p>

      <!-- Pagination -->
      <Pagination
        align="center"
        :data="depositData"
        @pagination-change-page="fetchUserDeposits"
        :limit="3"
        class="history-pagination"
      />
    </div>
  </div>
</template>
<script>
import Pagination from "laravel-vue-pagination";
import { DateTime } from "luxon";
import { Loading } from "vant";

export default {
  components: {
    Pagination,
    Loading,
  },
  data() {
    return {
      deposits: [],
      depositData: {},
      isDepositsFetching: true,
      filters: {
        page: 1,
        perPage: 5,
        date: null,
      },
      dateOptions: [],
    };
  },
  methods: {
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format("l");
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString(
        "en-US",
        {
          timeZone: targetTimeZone,
        }
      );
      return moment(adjustedDrawDate).format("lll");
    },
    async fetchUserDeposits(page = 1) {
      this.isDepositsFetching = true;
      try {
        this.filters.page = page;
        const response = await axios.get(
          `/users/${this.$store.state.authUser.id}/deposits`,
          {
            params: this.filters,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        this.depositData = response.data;
        this.deposits = response.data.data;
      } catch (error) {
        this.$toast.fail("Failed!");
      } finally {
        this.isDepositsFetching = false;
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case "confirm":
          return "အတည်ပြုပြီး";
        case "pending":
          return "လျှောက်ထားဆဲ";
        case "fail":
          return "အငြင်းခံရသည်";
        default:
          return status;
      }
    },
  },
  mounted() {
    this.setOneMonth();
    this.filters.date = moment(new Date()).format("l");
    this.fetchUserDeposits();
  },
};
</script>

<style scoped></style>
